import { motion } from "framer-motion";
import { Wallet, CalendarCheck2, Users } from "lucide-react";
import { SectionHeading } from "@/components/Reveal";

const BENEFITS = [
  {
    icon: Wallet,
    title: "Flessibilità & Guadagni",
    text: "Ottimi guadagni e massima libertà nella scelta di quando e dove lavorare. Sei tu a decidere i tuoi turni.",
    testid: "benefit-card-1",
  },
  {
    icon: CalendarCheck2,
    title: "Organizzazione & Benefit",
    text: "Organizza il tuo lavoro come preferisci e accedi a benefit crescenti in base a presenze e zone coperte.",
    testid: "benefit-card-2",
  },
  {
    icon: Users,
    title: "Competenze & Ambiente",
    text: "Lavora in team affinando problem solving, uso delle tecnologie, cordialità e professionalità. Ogni giorno.",
    testid: "benefit-card-3",
  },
];

export const BenefitsSection = () => (
  <section id="vantaggi" data-testid="benefits-section" className="relative py-24 sm:py-32 px-5 sm:px-8 bg-surface">
    <div className="hero-glow w-[400px] h-[400px] bg-brand/10 top-0 right-0" />
    <div className="relative max-w-6xl mx-auto">
      <SectionHeading
        eyebrow="02 — Vantaggi"
        title="I vantaggi di lavorare con Io Amo La Mia Città"
        sub="Non promettiamo scorciatoie: costruiamo un lavoro che si adatta alla tua vita."
        testid="benefits-title"
      />

      <div className="grid md:grid-cols-3 gap-5 sm:gap-6">
        {BENEFITS.map((b, i) => (
          <motion.div
            key={b.title}
            data-testid={b.testid}
            initial={{ opacity: 0, y: 48 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.75, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -8 }}
            className="group relative bg-card2 border border-brand/20 hover:border-brand/60 rounded-3xl p-8 transition-colors duration-300 overflow-hidden"
          >
            <div className="hero-glow w-40 h-40 bg-brand/20 -top-16 -right-16 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <div className="relative">
              <div className="w-14 h-14 rounded-2xl bg-brand/15 border border-brand/30 flex items-center justify-center mb-7 group-hover:bg-brand group-hover:scale-110 transition-all duration-300">
                <b.icon className="w-6 h-6 text-brand group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="font-display text-xl sm:text-2xl font-bold text-white mb-4">{b.title}</h3>
              <p className="text-sm sm:text-base leading-relaxed text-muted2">{b.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
